import { MAP_HEIGHT } from 'components/Map/constants';

export default function getMinumumZoomThatFits({ innerWidth , innerHeight}: Window) {
  // On sufficiently wide screens, we can show the map fully zoomed out
  if (innerWidth >= 768) {
    return 3;
  }

  // Otherwise, we need to show a zoom level that will fill the screen
  return 5 + Math.log2(innerHeight / MAP_HEIGHT);
}